import {
  SnippetElement,
  defineElement,
  liquidValue,
  param,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-accordion/util-accordion.ts
var UtilAccordion = class extends SnippetElement {
  constructor() {
    super();
    this.isOpen = false;
    this.inProgress = 0;
    this.initialHeight = null;
    this.init();
  }
  init() {
    return __async(this, null, function* () {
      if (this.key != null && UtilAccordion.states[this.key]) {
        this.classList.add("!duration-0");
        yield this.open();
        yield wait(10);
        this.classList.remove("!duration-0");
      }
    });
  }
  saveState() {
    if (this.key != null) {
      UtilAccordion.states[this.key] = this.isOpen;
    }
  }
  get mode() {
    var _a;
    return ((_a = this.classProp) != null ? _a : "").includes("block") ? "initialHeight" : "hidden";
  }
  getTransitionDuration() {
    var _a;
    return parseFloat((_a = getComputedStyle(this).transitionDuration) != null ? _a : 0) * 1e3;
  }
  getHeight() {
    const computedStyle = getComputedStyle(this);
    const elementHeight = this.clientHeight - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom));
    return elementHeight;
  }
  toggle() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        yield this.close();
      } else {
        yield this.open();
      }
    });
  }
  open() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        return;
      }
      if (this.initialHeight === null) {
        this.initialHeight = this.getHeight();
      }
      this.isOpen = true;
      this.inProgress++;
      this.style.maxHeight = `${this.initialHeight}px`;
      this.classList.add("block", "h-auto");
      if (this.mode === "hidden") {
        this.classList.add("opacity-100");
      }
      if (this.mode === "hidden") {
        this.classList.remove("hidden", "opacity-0", "h-0");
      }
      this.style.height = "auto";
      const height = this.scrollHeight;
      this.style.maxHeight = `${height}px`;
      yield wait(this.getTransitionDuration() + 1);
      if (this.inProgress <= 1) {
        this.style.removeProperty("max-height");
      }
      this.inProgress--;
      this.saveState();
      document.dispatchEvent(new CustomEvent("accordion-opened", { detail: { accordion: this } }));
    });
  }
  close() {
    return __async(this, null, function* () {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
      this.inProgress++;
      const height = this.scrollHeight;
      this.style.maxHeight = `${height}px`;
      if (this.mode === "hidden") {
        this.classList.add("opacity-0");
        this.classList.remove("opacity-100");
      }
      yield wait(1);
      this.style.maxHeight = `${this.initialHeight}px`;
      yield wait(this.getTransitionDuration() + 1);
      if (this.inProgress <= 1) {
        this.style.removeProperty("max-height");
        this.classList.remove("h-auto");
        if (this.mode === "hidden") {
          this.classList.remove("block");
          this.classList.add("hidden");
        }
        this.style.height = `${this.initialHeight}px`;
      }
      this.inProgress--;
      this.saveState();
    });
  }
  disconnectedCallback() {
    this.remove();
  }
};
UtilAccordion.states = {};
__decorateClass([
  param("key")
], UtilAccordion.prototype, "key", 2);
__decorateClass([
  liquidValue("class")
], UtilAccordion.prototype, "classProp", 2);
UtilAccordion = __decorateClass([
  defineElement("util-accordion")
], UtilAccordion);
export {
  UtilAccordion
};
